import { AnimatePresence, motion, type Transition } from 'motion/react';
import { useReducedMotion } from '../lib/useReducedMotion';

/** «Пружина» арени: помітний перельот, швидке заспокоєння. */
export const SPRING: Transition = { type: 'spring', stiffness: 420, damping: 26, mass: 0.7 };

export interface PopProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  /** Ключ, зміна якого перезапускає анімацію. */
  id?: string | number;
}

/**
 * Поява з «підстрибуванням». При prefers-reduced-motion (або власному
 * перемикачі дитини) вироджується у звичайний div без жодного руху.
 */
export function Pop({ children, className, delay = 0, id }: PopProps): React.JSX.Element {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;

  return (
    <motion.div
      key={id}
      className={className}
      initial={{ opacity: 0, scale: 0.92, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96, y: -8 }}
      transition={{ ...SPRING, delay }}
    >
      {children}
    </motion.div>
  );
}

export interface TapScaleProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

/** Кнопка з відчутним відгуком на тап — основа «соковитості» інтерфейсу. */
export function TapScale({ children, ...rest }: TapScaleProps): React.JSX.Element {
  const reduced = useReducedMotion();
  if (reduced) {
    return (
      <button type="button" {...rest}>
        {children}
      </button>
    );
  }
  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.96 }}
      whileHover={{ scale: 1.01 }}
      transition={SPRING}
      {...(rest as React.ComponentProps<typeof motion.button>)}
    >
      {children}
    </motion.button>
  );
}

export { AnimatePresence, motion };
